const {default: Axios} = require('axios')

const axiosInstance = Axios.create({
    baseURL: window.API || 'https://cc.wx1.de',
})

axiosInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

export default axiosInstance
